// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2AgfH","actions":"GroupTable_actions__2CdGZ","deleteModalFooter":"GroupTable_deleteModalFooter__1ZWrH"};